<div class="text-white border-radius-50 k-line-height-md square-24 text-center" [ngClass]="disabled() ? 'bg-green-disabled' : 'bg-green-dark'">
    <kendo-icon name="plus"
                [size]="'small'"></kendo-icon>
</div>


@if (showDialog()) {
    <kendo-dialog title="Assign Organization"
                  (close)="close()"
                  [minWidth]="250"
                  [width]="450">
        <kendo-combobox [data]="organizations()"
                        [placeholder]="'Organization'"
                        [valuePrimitive]="false"
                        [textField]="'name'"
                        [valueField]="'id'"
                        [clearButton]="false"
                        [popupSettings]="{ width: 'auto'}"
                        [(value)]="organization"
                        class="mb-3">
        </kendo-combobox>
        <kendo-combobox [data]="organizationTypesOfSelectedOrganization()"
                        [placeholder]="'Type'"
                        [valuePrimitive]="true"
                        [valueField]="'organizationTypeId'"
                        [textField]="'organizationTypeName'"
                        [clearButton]="false"
                        [popupSettings]="{ width: 'auto'}"
                        [(value)]="organizationTypeId">
        </kendo-combobox>
        <kendo-dialog-actions [layout]="'end'">
            <button kendoButton
                    (click)="close()">Close</button>
            <button kendoButton
                    (click)="assignOrganizationAndType()"
                    themeColor="primary"
                    [disabled]="assignIsDisabled()">
                Assign
            </button>
        </kendo-dialog-actions>
    </kendo-dialog>
}